import LiveOverview from '../features/live/layouts/live-overview';

export default function LivePage() {
    return <LiveOverview />;
}
